module.exports = __webpack_public_path__ + "img/26-jeep-grand-cherokee.a23bc72b.jpg";